import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DataGrid, itIT, GridToolbar, useGridApiRef } from '@mui/x-data-grid';
import { Box, Alert } from '@mui/material';

import Api from '../../Services/Api';
import { PAGE_SIZE, pageSizeOptions } from '../../Config/constants.js';

function InstallationSpareList() {
    const { installation } = useParams();
    const apiRef = useGridApiRef();

    const [rows, setRows] = useState([]);
    const [displayAlert, setDisplayAlert] = useState(0);

    const columns = [
        {
            field: 'repair_date',
            headerName: 'Data riparazione',
            flex: 1,
            type: 'date',
            valueGetter: (params) => params.row?.repair_date ? new Date(params.row.repair_date) : null,
            valueFormatter: (params) => {
                if (!params.value) return '';
                return new Date(params.value).toLocaleDateString('it-IT');
            },
        },
        {
            field: 'technician',
            headerName: 'Tecnico',
            flex: 2,
        },
        {
            field: 'code',
            headerName: 'Cod. Ricambio',
            flex: 1,
        },
        {
            field: 'short_description',
            headerName: 'Ricambio',
            flex: 3,
        },
        {
            field: 'quantity',
            headerName: 'Quantità',
            flex: 1,
            valueGetter: (params) => params.row.quantity ?? null,
            valueFormatter: (params) => params.value !== null ? params.value : '-',
        },
    ];

    useEffect(() => {
        try {
            Api.get({ endpoint: `installation/${installation}/spares`, contentType: 'application/json' })
                .then(response => {
                    setRows(response.data.spares);
                })
                .catch(error => {
                    console.log(JSON.stringify(error));
                    setDisplayAlert(-1);
                });
        } catch (error) {
            console.log(JSON.stringify(error));
            setDisplayAlert(-1);
        }
    }, [installation]);  // eslint-disable-line react-hooks/exhaustive-deps

    const theme = createTheme(
        {
            palette: {
                primary: { main: '#11cb5f' },
            },
        },
        itIT,
    );

    return (
        <>
            <h5>Ricambi</h5>
            <Box sx={{ width: '100%', minWidth: '800px' }}>
                <ThemeProvider theme={theme}>
                    <DataGrid
                        sx={{ minHeight: '300px' }}
                        rows={rows}
                        columns={columns}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: PAGE_SIZE,
                                },
                            },
                            sorting: {
                                sortModel: [{ field: 'repair_date', sort: 'desc' }],
                            },
                        }}
                        apiRef={apiRef}
                        slots={{
                            toolbar: GridToolbar,
                        }}
                        slotProps={{
                            columnsPanel: {
                                disableHideAllButton: true,
                            },
                        }}
                        pageSizeOptions={pageSizeOptions}
                    />
                </ThemeProvider>
                {displayAlert === -1 && (
                    <Alert severity="error">Si è verificato un errore imprevisto. Riprovare più tardi</Alert>
                )}
            </Box>
        </>
    );
}

export default InstallationSpareList;
